import { createSubscriptionHook } from '~/shared/providers/api';

export const useSidecarEventsSubscription = createSubscriptionHook(
  'iot.sidecarEvents',
  () => ({
    iotSidecarEvents: {
      id: true,
      name: true,
      operatingSystem: true,
      operatingSystemVersion: true,
      localIpAddress: true,
      remoteIpAddressV4: true,
      remoteIpAddressV6: true,
      linkSpeedUpstream: true,
      linkSpeedDownstream: true,
      latencyMs: true,
      jitterMs: true,
      peerId: true,
      multiaddrs: true,
      status: true,
      lastHeartbeatAt: true,
      connectedAt: true,
      facilityId: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    select: ({ iotSidecarEvents }) => iotSidecarEvents,
  },
);
